
export class Unidades {
    id: number;
    descripcion: string;
    factor: number;
    idEmisor: number;
    tipoUnidad: string;
    precio: number;
    }

    